module.exports = __webpack_public_path__ + "static/logo-pignol-b7d317163a6fe94239ce824e678adf82.svg";